import {Component, OnInit, OnChanges, ElementRef, Input, ChangeDetectorRef, Output, EventEmitter} from '@angular/core';

import {CDSNode, Rule} from '../services/capd.model';
import { UserService } from '../services/user.service';
import {OrgService} from "../services/org.service";
import {ROOT_ORGS} from "../capd-admin-component/capd-admin.component";
import {OrgDataService} from "../services/org-data.service";
import {isObservable} from "rxjs";
import {AlertService} from "../services/alert.service";
import {CDSTreeService} from "../services/cds.service";

declare var $: any;

@Component({
  selector: 'user-list',
  templateUrl: './user-list.component.html',
})

/**
 * Component for displaying the list of users.
 */
export class UserListComponent implements OnInit, OnChanges {

  @Input() filter = '';
  @Input() org: CDSNode;

  @Output() status: EventEmitter<any> = new EventEmitter();
  @Output() userCountUpdate: EventEmitter<number> = new EventEmitter();
  loading: boolean = true;
  oldOrg: string;
  users: CDSNode[];
  filteredUsers: CDSNode[];
  selectedUser: CDSNode;
  showUserConfig: boolean = false;
  watermarkText = '<span>Loading...<br /><img src="./app/css/img/linear-loader.gif" alt=""/></span>';
  userRules: Rule[];
  originalRules: Rule[];
  ruleEdits: Rule[] = [];
  loadingError: boolean = false;
  modalLoadingError: boolean = false;
  version: string = 'Classic';


  constructor(private _service: UserService,
              private _el: ElementRef,
              private _cdr: ChangeDetectorRef,
              private _settings: OrgService,
              private _orgDataService: OrgDataService,
              private alertService: AlertService,
              private _cds: CDSTreeService) { }

  /**
   * Gets the list of all users and displays them alphabetically.
   *
   * @async
   * @func ngOnInit
   */
  ngOnInit() {
    this.version = sessionStorage.getItem('uiVersion')
    this.watermarkText = '<span>Loading...<br /><img src="./app/css/img/linear-loader.gif" alt=""/></span>';
    const root = this.org.rootId;
    const group = this.org.extensionId;
    this.oldOrg = root + '+' + group;

    this.initModal();
  }

  onRightClick($event, user: CDSNode) {
    const userOID = user.rootId + '/' + user.extensionId;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = userOID;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alertService.showAlert("User OID: " + userOID + " copied");
    return false;
  }

  initModal() {
    this.watermarkText = '<span>Loading...<br /><img src="./app/css/img/linear-loader.gif" alt="" /></span>';

    if(this.org && this.selectedUser) {
      // get settings
      let rootId = '';
      let i = 2;
      rootId = this.org.rootId
    }
  }

  /**
   * If the org has changed, re-get the list of users.
   * Otherwise, assume the user is doing a search, and filter the list of visible users based on the search.
   *
   * @async
   * @func ngOnChanges
   */
  async ngOnChanges() {
    this.loading = true;
    // if we cannot find a root id, then we also have no users
    if(this.org.rootId == undefined) {
      this.filteredUsers = []
      this.loading = false;
    }
    else if (this.oldOrg !== this.org.rootId + '+' + this.org.extensionId) {
      let i = 0;
      const root = this.org.rootId;
      const group = this.org.extensionId;
      this.oldOrg = root + '+' + group;
      let split_root = root.split('.');
      let org_root = "~." + split_root[1];

      if (this._orgDataService.getCurrentOrg() && this._orgDataService.getCurrentOrg().users)
        this.users = this._orgDataService.getCurrentOrg().users;
      else {
        // if no users found, check backend for missing users
        await this._service.getUsers(root, group).then((users: CDSNode[]) => {
          if(isObservable(users)) {
              this.loading = false;
              this.loadingError = true;
          }
          else {
            this.users = users;
          }
        })
        if(!this.users)
          this.users = []
      }


        if(this.users.length == 0){
          this.loading = false;
        }

        this.users.forEach(user => {
          if (!user.description)
            { user.description = 'null'; }
        });

        // alphabetically sort this.users and save that value to this.filteredUsers
        this.filteredUsers = this.users.sort((a, b) => a.description.localeCompare(b.description));
        if (this.filter) {
          this.filteredUsers = this.filteredUsers.filter(user => {
            const isDescriptionMatch = user && user.description && user.description.toUpperCase().includes(this.filter.toUpperCase());
            const isUsernameMatch = user && user.userLoginName && user.userLoginName.toUpperCase().includes(this.filter.toUpperCase());
            return isDescriptionMatch || isUsernameMatch;
          });
        }

        await this.filteredUsers
        this.loading = false
    }
    else {

        this.filteredUsers = this.users.sort((a, b) => a.description.localeCompare(b.description));
        if (this.filter) {
          this.filteredUsers = this.filteredUsers.filter(user => {
            const isDescriptionMatch = user && user.description && user.description.toUpperCase().includes(this.filter.toUpperCase());
            const isUsernameMatch = user && user.userLoginName && user.userLoginName.toUpperCase().includes(this.filter.toUpperCase());
            return isDescriptionMatch || isUsernameMatch;
          });
        }
        this.loading = false;
    }
    this._service.getModifiedUsersByOrg(this.org.rootId).then((data: string[]) => {
      this.filteredUsers.forEach(user => {
        if(data.includes(user.rootId))
          user.modified = true;
        else
          user.modified = false;
      })
    });
    this.userCountUpdate.emit(this.filteredUsers.length);
  }

  isUnchanged() {
    return (JSON.stringify(this.originalRules) === JSON.stringify(this.userRules));
  }

  /**
   * When the user is changed, call this function again to load the new rules.
   *
   * @async
   */
  async getUserRules() {
    this.version = sessionStorage.getItem('uiVersion')
    this.watermarkText = '<span>Loading...<br /><img src="../css/img/linear-loader.gif" alt="" /></span>';
    this.modalLoadingError = false;

    try {
      if (!this.org || !this.selectedUser) {
        this.userRules = [];
        this.originalRules = [];
        this.watermarkText = '<span>There are no rules to display for this user.</span>';
        return;
      }

      const groupShortOids = this.selectedUser.groupShortOids;
      if (!groupShortOids || groupShortOids.length < 1) {
        this.userRules = [];
        this.originalRules = [];
        this.watermarkText = '<span>There are no rules to display for this user.</span>';
        return;
      }

      if (this.version == 'Version 2') {
        const rules = await this._service.getRulesForUserByGroups(groupShortOids) as Rule[];
        this.userRules = rules && rules.length
          ? rules.sort((a, b) => a.triggerCode.localeCompare(b.triggerCode))
          : [];
      } else {
        const topRoot = await this.calculateTopRoot();
        const rootId = "~." + topRoot;
        const rules = await this._service.getUserRules(rootId, this.selectedUser.rootId, groupShortOids) as Rule[];
        this.userRules = rules && rules.length
          ? rules.sort((a, b) => {
            const test1 = a.contentPackage_id.localeCompare(b.contentPackage_id);
            if (test1 !== 0) {
              return test1;
            } else {
              return a.triggerName.localeCompare(b.triggerName);
            }
          })
          : [];
      }

      this.originalRules = JSON.parse(JSON.stringify(this.userRules));
      this.watermarkText = '<span>There are no rules to display for this user.</span>';
    } catch (error) {
      console.error(error);
      this.userRules = [];
      this.originalRules = [];
      this.modalLoadingError = true;
      this.watermarkText = '<span>Error loading rules for this user. Please refresh and try again.</span>';
    } finally {
      this.initModal();
      this.loading = false;
    }
  }

  /**
   * Selects one user for finer editing.
   *
   * @func selectUser
   * @param {CDSNode} user - the user being selected.
   */
  selectUser(user) {
    this.userRules = null;
    this.selectedUser = user;
    this.modalLoadingError = false;
    this.loading=true;
    this.getUserRules();
    $("#modal-configure-user").toggle('show');

  }

  cancelConfig() {
    $("#modal-configure-user").toggle('show');
    this.ruleEdits = []; // clear saved rule configs
  }

  saveConfig() {
    this._service.updateUserRules(this.org.rootId, this.selectedUser.rootId, this.ruleEdits).then(() => this.ruleEdits = []);
    $("#modal-configure-user").toggle('show');
    this.ruleEdits = [];
    this.selectedUser.modified = true;
  }

  /**
   * Prints a list of all groups a user is in.
   *
   * @func printUserGroups
   * @param {any} user - a given user.  I don't believe groupNames is on the basic CDSNode object, but a user here is basically that.
   * @returns a string of all non-null groupNames, separated by commas.
   */
  printUserGroups(user) {
    let groupString = '';
    const noNull: string[] = user.groupNames.filter(group => !!group);
    for (let i = 0; i < noNull.length - 1; i++) {
      groupString += noNull[i] + ', ';
    }

    if (noNull.length > 0) {
      groupString += noNull[noNull.length - 1];
    }

    return groupString;
  }

  /**
   * Checks if the user has a personal override on the rule state.
   * If so, return that; otherwise, return the setting of that rule for the group.
   *
   * @func getRuleState
   * @param {Rule} rule - the rule whose state is being checked.
   * @returns "Enabled," "Silent" or "Disabled," depending on the rule's state.
   */
  getRuleState(rule: Rule): string {
    if (!rule.state && !rule.uState) {
      return 'Enabled';
    }
    else if (!!rule.uState) {
      return rule.uState;
    }
    else {
      return rule.state;
    }
  }

  getRuleStateV2(rule: Rule): string {
    if (rule.triggerSilent) {
      return 'Silent';
    } else {
      return 'Enabled';
    }
  }

  openDropdown() {
    $('#stateOptions').toggle('show');
  }

  closeDropdown() {
    $('#stateOptions').hide();
  }

  /**
   * Adds or removes a rule from the list of rules to edit.
   *
   * @func onSelect
   * @param {Rule} rule - the rule to add or remove.
   */
  onSelect(rule: Rule) {
    const index = this.ruleEdits.indexOf(rule);
    if (index < 0) {
      this.ruleEdits.push(rule);
    }
    else {
      this.ruleEdits.splice(index, 1);
    }
  }

  /**
   * Uses the checkbox on the header to select/deselect all rules automatically.
   *
   * @func onHeaderSelect
   */
  onHeaderSelect() {
    if (this.ruleEdits.length >= this.userRules.length) {
      this.ruleEdits.splice(0, this.ruleEdits.length);
    } else {
      this.userRules.forEach(rule => this.addAll(rule));
    }

    if($('#selectAllRules').is(':checked')) {
      $('input[type=checkbox]').prop('checked', true);
    } else {
      $('input[type=checkbox]').prop('checked', false);
    }
  }

  checkSelected() {
    if($('input[type=checkbox]:not(:checked)')) {
      $('#selectAllRules').prop('checked', false);
    }
  }

  /**
   * Adds all rules not currently selected, one by one.
   *
   * @func addAll
   * @param {Rule} rule - the current rule being added.
   */
  addAll(rule: Rule) {
    const index = this.ruleEdits.indexOf(rule);
    if (index < 0 && (!rule.state || rule.state === 'Enabled')) {
      this.ruleEdits.push(rule);
    }
  }

  /**
   * Submits changes to the server.
   *
   * @async
   * @func onSubmit
   * @param {string} newState - the new state to apply to the rules.
   */
  onSubmit(newState: string) {
    this.ruleEdits.forEach(rule => rule.uState = newState);
    this.closeDropdown();
    $('input[type=checkbox]').prop('checked', false);
  }

  async getTreeRoots() {
    const storedTreeRoots = sessionStorage.getItem('treeRoots');
    if (storedTreeRoots) {
      return storedTreeRoots.split(',');
    }

    const roots = await this._cds.getTreeRoots();
    sessionStorage.setItem('treeRoots', roots);
    return roots.split(',');
  }

  async calculateTopRoot() {
    let treeRoots: string[] = await this.getTreeRoots();
    let tempRoot = this.org.rootId.replace('~', '2.16.840.1.113883.3.21');

    for (const root of treeRoots) {
      if(this.org.rootId.includes(root)) {
        return tempRoot.replace(root + '.', '').split('.').at(0);
      }
    }

    return tempRoot.replace('2.16.840.1.113883.3.21.', '').split('.').at(0);
  }

}
